import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';

const ProcessSection = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start'],
  });

  const lineProgress = useTransform(scrollYProgress, [0.2, 0.8], [0, 100]);

  const steps = [
    {
      number: '01',
      icon: 'ri-phone-line',
      title: 'Contacto inicial',
      description:
        'Llámanos, envíanos un WhatsApp o rellena nuestro formulario. Cuéntanos qué necesitas y te responderemos rápidamente.',
    },
    {
      number: '02',
      icon: 'ri-calculator-line',
      title: 'Presupuesto personalizado',
      description:
        'Evaluamos tu caso y te enviamos un presupuesto detallado sin compromiso. Transparencia total en nuestros precios.',
    },
    {
      number: '03',
      icon: 'ri-calendar-check-line',
      title: 'Coordinación y fecha',
      description:
        'Acordamos la fecha que mejor te convenga. Nos coordinamos con portería y administración de fincas.',
    },
    {
      number: '04',
      icon: 'ri-truck-line',
      title: 'Vaciado profesional',
      description:
        'Nuestro equipo realiza el vaciado protegiendo zonas comunes. Rápido, limpio y eficiente.',
    },
    {
      number: '05',
      icon: 'ri-recycle-line',
      title: 'Gestión de residuos',
      description:
        'Llevamos todo a puntos autorizados. Donamos objetos en buen estado a entidades sociales.',
    },
    {
      number: '06',
      icon: 'ri-checkbox-circle-line',
      title: 'Entrega y documentación',
      description:
        'Te entregamos el inmueble vacío y limpio. Certificado de gestión de residuos incluido.',
    },
  ];

  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="inline-block bg-orange-bg text-orange text-xs font-bold uppercase tracking-wider px-4 py-1.5 rounded-full mb-4">
            Cómo trabajamos
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-5">
            Proceso simple y transparente
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Desde el primer contacto hasta la entrega final, te acompañamos en cada paso. 
            Conoce <a href="/empresa" className="text-orange hover:underline font-medium">nuestra forma de trabajar</a> y por qué somos tu mejor opción.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-shadow"
            >
              <div className="absolute -top-4 -left-4 w-12 h-12 bg-orange text-white rounded-xl flex items-center justify-center font-bold text-lg shadow-lg">
                {step.number}
              </div>
              <div className="w-14 h-14 bg-orange-bg rounded-xl flex items-center justify-center mb-5">
                <i className={`${step.icon} text-2xl text-orange`}></i>
              </div>
              <h3 className="text-xl font-bold text-navy mb-3">{step.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-gray-600 mb-6">
            ¿Tienes dudas sobre el proceso? Consulta nuestras <a href="/faq" className="text-orange hover:underline font-medium">preguntas frecuentes</a> o <a href="/contacto" className="text-orange hover:underline font-medium">contáctanos directamente</a>.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ProcessSection;
